module.exports = __webpack_public_path__ + "images/b569fad5.png";